import React from "react";
import Navigationbar from "../Components/Navbar/Navbar";
import Spacer from "../Components/Spacer/Spacer";
import ContactCard from "../Components/ContactCard/ContactCard";
import Map from "../Components/Map/Map";
import { Container } from "react-bootstrap";
import Footer from "../Components/Footer/Footer";
import ContactCard2 from "../Components/ContactCard/ContactCard2";
function ContactUs() {
  return (
    <>
      <Navigationbar />
      {/* <Spacer /> */}
      {/* <Container> 
      <ContactCard /> */}
      <ContactCard2 />
      {/* <Map /> */}
      {/* </Container> */}
      {/* <Spacer /> */}
      {/* <Footer/>  */}
    </>
  );
}

export default ContactUs;
